import { Box, alpha } from '@mui/material';
import { styled } from '@mui/material/styles';
import ErrorIcon from '@mui/icons-material/Error';
import Tooltip from 'src/components/Tooltip';
import { translate } from 'src/i18n/tHelper';
import React from 'react';
import { useAppDispatch, useAppSelector } from 'src/store';
import { RedPanikSlice } from 'src/store/Slices/RedPanik/RedPanikSlice';
import RedPanik from 'src/content/applications/RedPanik';

const RejectionButton = styled(Box)(
  ({ theme }) => `
    height: 28px;
    padding: 0 8px;
    border-radius: 4px;
    background: transparent;
    border: 1px solid ${alpha(theme.palette.error.main, 0.3)};
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 11px;
    font-weight: 700;
    color: ${theme.palette.error.main};
    margin: 0 1px;
    min-width: auto;
    cursor: pointer;
    
    @keyframes pulseAnim {
      0% {
        opacity: 0.5;
        transform: scale(0.97);
        box-shadow: 0 0 0px rgba(211, 47, 47, 0);
      }
      50% {
        opacity: 1;
        transform: scale(1.03);
        box-shadow: 0 0 8px rgba(211, 47, 47, 0.4);
      }
      100% {
        opacity: 0.5;
        transform: scale(0.97);
        box-shadow: 0 0 0px rgba(211, 47, 47, 0);
      }
    }
    
    @keyframes iconPulseAnim {
      0% {
        transform: scale(0.9);
      }
      50% {
        transform: scale(1.1);
      }
      100% {
        transform: scale(0.9);
      }
    }
    
    animation: pulseAnim 1s ease-in-out infinite;
    
    &:hover {
      background: ${alpha(theme.palette.error.main, 0.12)};
      border-color: ${alpha(theme.palette.error.main, 0.6)};
      box-shadow: 0 2px 8px ${alpha(theme.palette.error.main, 0.25)} !important;
      animation: none;
    }
    
    .MuiSvgIcon-root {
      font-size: 18px;
      animation: iconPulseAnim 1s ease-in-out infinite;
    }
  `
);

interface RedPanikAlertProps {
  count?: number;
}

const translatePath = "common";
const RedPanikAlert = (props: RedPanikAlertProps) => {
  const { count = 0 } = props;
  const state = useAppSelector(s => s.redPanik);
  const dispatch = useAppDispatch();
  const handlerRedPanik = (event: React.MouseEvent<HTMLDivElement, MouseEvent>): void => {
    dispatch(RedPanikSlice.actions.setOpen(true));
  }
  return (
    <>
      <Tooltip arrow title={translate(translatePath, "İşlem Red Sayısı")}>
        <RejectionButton onClick={handlerRedPanik}>
          <ErrorIcon />
          {count} {translate(translatePath, "işlem red edildi")}
        </RejectionButton>
      </Tooltip>
      {state.open && <RedPanik open={state.open} />}
    </>
  );
};

export default RedPanikAlert;
